export default function(instance) {
  return {
    getCounters(data) {
      Object.keys(data).forEach(
        k => !data[k] && data[k] !== undefined && delete data[k]
      );

      return instance.get("/api/counters/admin/", { params: data });
    },
    createCounter(data) {
      return instance.post("/api/counters/admin/", {
        counter_number: data.counter_number,
        kind: data.kind,
        home: data.home
      });
    },
    getCounter(idCounter) {
      return instance.get(`/api/counters/admin/${idCounter}/`);
    },
    updateCounter(idCounter, data) {
      return instance.put(`/api/counters/admin/${idCounter}/`, {
        counter_number: data.counter_number,
        status: data.status,
        home: data.home
      });
    },
    deleteCounter(idCounter) {
      return instance.delete(`/api/counters/admin/${idCounter}/`);
    },

    updateIndication(data) {
      return instance.post("/api/indications/", {
        counter_number: data.counter_number,
        homestead_number: data.homestead_number,
        indications: data.indications,
        kind: data.kind
      });
    }
  };
}
